import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Popup from '@/components/Popup/index.jsx';

import imgBg from '@/assets/images/complete/bg.png';
import imgClose from '@/assets/images/complete/close.png';
import imgQrcode from '@/assets/images/qrcode.png';

import styles from './index.less';

const Complete=(props)=>{
  const {destory,count='-'} = props;


  const onClose=()=>{
    destory(false);
    location.href='/#/'
  }

  return (
    <section className={styles.center}>
      <section className={`${styles.wrap}`} >
        <img className={styles.bg} src={imgBg} />

        <section className={styles.content}>
          <span>感谢您</span>
          <span className={styles.space}>在恺心公益·心愿树活动中</span>
          <span>帮助了<span className={styles.count}>{count}</span>位小朋友，实现心愿</span>
        </section>

        <div  className={styles.qrcode}>
          <img src={imgQrcode} />
        </div>

      </section>
      <div onClick={onClose} className={styles.close}>
        <img src={imgClose} />
      </div>

    </section>
  )
}

const ShowComplete=(props)=>{
  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <Complete  destory={popup.destory} count={props.count} />,
      popup.dom
    );
  })
}

export default ShowComplete;